import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { User, UserProfile, UserRelationship, UserRoleType } from "@apiserver-rest/ponder-data-client-base";
import { formatDateShort } from "@ponder-shared/utils/numberFormatter";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { ProfileInfoFormComponent } from "./profile-info-form.component";
import { Subscription } from "rxjs";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { getProfileImageRoute } from "./profile-image-router";
import { AuthService } from "@ponder-core/auth/auth.service";
import { ProfileRelationshipStatusComponent } from "./profile-relationship-status.component";
import { ProfileRoleBadgeComponent } from "./profile-role-badge.component";

@Component({
    selector: "profile-info",
    imports: [ProfileInfoFormComponent, ProfileRelationshipStatusComponent, ProfileRoleBadgeComponent],
    templateUrl: "./profile-info.component.html"
})
export class ProfileInfoComponent {
    @Input({ required: true }) public user!: User;
    @Input({ required: true }) public profile!: UserProfile;
    @Input({ required: true }) public userRole!: UserRoleType;
    @Input({ required: true }) public relationship?: UserRelationship;
    @Input({ required: true }) public isOwnProfile!: boolean;

    public readonly linkSvgIcon: string = SvgIconMap.get(SvgIcon.Link)!;
    public readonly calendarSvgIcon: string = SvgIconMap.get(SvgIcon.Calendar)!;

    public joinedAt?: string;
    public avatarUrl!: string;
    public isAuthed!: boolean;
    public hasNoRoleBadge: boolean = true;

    public isEditing: boolean = false;
    public isSaving: boolean = false;
    public savingFailed: boolean = false;

    private hideProfileFormSub!: Subscription;
    private avatarUrlUpdatedSub!: Subscription;

    constructor(private ponderDataClient: PonderDataClient, private events: EventBroker, private auth: AuthService) {
        this.hideProfileFormSub = this.events.profile.hideProfileFormEvent.subscribe({
            next: () => {
                this.isEditing = false;
            }
        });

        this.avatarUrlUpdatedSub = this.events.profile.profileAvatarUpdatedEvent.subscribe({
            next: () => {
                this.avatarUrl = getProfileImageRoute(this.user.username!);
            }
        });
    }

    public ngOnDestroy(): void {
        this.hideProfileFormSub?.unsubscribe();
        this.avatarUrlUpdatedSub?.unsubscribe();
    }

    public ngOnInit(): void {
        this.joinedAt = `Joined ${formatDateShort(this.user.createdAt)}`;
        this.avatarUrl = getProfileImageRoute(this.user.username!);
        this.isAuthed = this.auth.isAuthed();
        this.hasNoRoleBadge = (this.userRole == UserRoleType.User) || (this.userRole == UserRoleType.None);
    }

    public getDisplayName(): string {
        if (this.user?.displayName) {
            if (this.user.displayName.length != 0) {
                return this.user.displayName;
            }
        }

        return this.user.username!;
    }

    public onEditClicked(): void {
        this.isEditing = true;
    }

    public onAddFriendClicked(): void {

    }

    public formatUrl(str: string): string {
        try {
            var url = new URL(str);

            if (url.pathname.length > 1) {
                return `${url.hostname}${url.pathname}`;
            } else {
                return url.hostname;
            }
        } catch {
            return str;
        }
    }
}